import { render, staticRenderFns } from "./ManageAddresses.vue?vue&type=template&id=ce2add8e&scoped=true"
import script from "./ManageAddresses.vue?vue&type=script&lang=js"
export * from "./ManageAddresses.vue?vue&type=script&lang=js"
import style0 from "./ManageAddresses.vue?vue&type=style&index=0&id=ce2add8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce2add8e",
  null
  
)

export default component.exports